import { QueryModelCore } from "@/core/model.core";

export default class Pet {
  /**
   * 携宠游首页
   */
  async getTopicHome() {
    const result = await new QueryModelCore('/api-cms/app/cate/topicHome').get({ cateType: 1 });
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 宠物列表查询
   */
  async getMemPetList() {
    const result = await new QueryModelCore('/api-mem/personal/memPet/list').get();
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 携宠游订单列表
   */
  async petOrderPagingList(params) {
    const result = await new QueryModelCore('/api-trade/tradeApplet/getMyPetTrade').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 获取宠物品种列表
   */
  async getBreedList(params) {
    const result = await new QueryModelCore('/api-mem/memPet/breedList').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 宠物详情查询
   */
  async getMemPetInfo(params) {
    const result = await new QueryModelCore('/api-mem/personal/memPet/query').get(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 添加宠物信息
   */
  async addMemPet(params) {
    const result = await new QueryModelCore('/api-mem/personal/memPet/add').post(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 删除宠物信息
   */
  async deleteMemPet(params) {
    const result = await new QueryModelCore('/api-mem/personal/memPet/delete').post(params);
    const { dataMap } = result;
    return dataMap;
  }

  /**
   * 更新宠物信息
   */
  async updateMemPet(params) {
    const result = await new QueryModelCore('/api-mem/personal/memPet/update').post(params);
    const { dataMap } = result;
    return dataMap;
  }

}